import { render, staticRenderFns } from "./Colegiada.vue?vue&type=template&id=692067ba&"
import script from "./Colegiada.vue?vue&type=script&lang=js&"
export * from "./Colegiada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports